const REFERRAL_CODE_STORAGE_KEY = "referral_code";
const REFERRAL_CODE_PATTERN = /^[A-Z0-9]{6,32}$/;
const REFERRAL_CODE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

interface StoredReferralCode {
  code: string;
  expiresAt: number;
}

export const normalizeReferralCode = (value: string | null | undefined): string | null => {
  const normalized = value?.trim().toUpperCase() ?? "";
  return REFERRAL_CODE_PATTERN.test(normalized) ? normalized : null;
};

export const storeReferralCode = (value: string): string | null => {
  const normalized = normalizeReferralCode(value);
  if (normalized) {
    const stored: StoredReferralCode = {
      code: normalized,
      expiresAt: Date.now() + REFERRAL_CODE_TTL_MS,
    };
    localStorage.setItem(REFERRAL_CODE_STORAGE_KEY, JSON.stringify(stored));
  } else {
    localStorage.removeItem(REFERRAL_CODE_STORAGE_KEY);
  }
  return normalized;
};

export const getStoredReferralCode = (): string | null => {
  const value = localStorage.getItem(REFERRAL_CODE_STORAGE_KEY);
  if (!value) return null;

  try {
    const stored = JSON.parse(value) as Partial<StoredReferralCode>;
    const normalized = normalizeReferralCode(stored.code);
    if (!normalized || typeof stored.expiresAt !== "number" || stored.expiresAt <= Date.now()) {
      localStorage.removeItem(REFERRAL_CODE_STORAGE_KEY);
      return null;
    }
    return normalized;
  } catch {
    localStorage.removeItem(REFERRAL_CODE_STORAGE_KEY);
    return null;
  }
};

export const clearStoredReferralCode = () => {
  localStorage.removeItem(REFERRAL_CODE_STORAGE_KEY);
};

export const buildReferralLink = (
  referralCode: string,
  origin = window.location.origin
): string => {
  const normalized = normalizeReferralCode(referralCode);
  if (!normalized) throw new Error("Некорректный реферальный код");
  return `${origin.replace(/\/+$/, "")}/ref/${normalized}`;
};
